import * as React from "react";
const SvgSmartphone = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12.5002 0H7.50016C6.3955 0.00132321 5.33646 0.440735 4.55535 1.22185C3.77423 2.00296 3.33482 3.062 3.3335 4.16667V15.8333C3.33482 16.938 3.77423 17.997 4.55535 18.7782C5.33646 19.5593 6.3955 19.9987 7.50016 20H12.5002C13.6048 19.9987 14.6639 19.5593 15.445 18.7782C16.2261 17.997 16.6655 16.938 16.6668 15.8333V4.16667C16.6655 3.062 16.2261 2.00296 15.445 1.22185C14.6639 0.440735 13.6048 0.00132321 12.5002 0ZM7.50016 1.66667H12.5002C13.1632 1.66667 13.7991 1.93006 14.2679 2.3989C14.7368 2.86774 15.0002 3.50363 15.0002 4.16667V13.3333H5.00016V4.16667C5.00016 3.50363 5.26355 2.86774 5.7324 2.3989C6.20124 1.93006 6.83712 1.66667 7.50016 1.66667ZM12.5002 18.3333H7.50016C6.83712 18.3333 6.20124 18.0699 5.7324 17.6011C5.26355 17.1323 5.00016 16.4964 5.00016 15.8333V15H15.0002V15.8333C15.0002 16.4964 14.7368 17.1323 14.2679 17.6011C13.7991 18.0699 13.1632 18.3333 12.5002 18.3333Z",
      fill: "#5A5C5E"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.0002 17.4995C10.4605 17.4995 10.8336 17.1264 10.8336 16.6662C10.8336 16.2059 10.4605 15.8328 10.0002 15.8328C9.53999 15.8328 9.1669 16.2059 9.1669 16.6662C9.1669 17.1264 9.53999 17.4995 10.0002 17.4995Z",
      fill: "#5A5C5E"
    }
  )
);
export default SvgSmartphone;
